import Background from "./Background";

const ParentContainor = ({
    route,
    children,
    parentContainorStyle,
    showCopyRightText,
    padding,
    disablePadding,
    backgroundContainorStyle,
    isShowHeader = false,
    isBreadcrumbVisible = false,
    breadCrumbShowBack = true,
    isShowRapFireLeaderboardSpotlight = false,
    showBlurredBg = false,
    breadCrumbOnBack,
    breadCrumbItems,
}) => {
    return (
        <div className="parent-containor" style={parentContainorStyle}>
            <Background
                showText={showCopyRightText}
                padding={padding}
                disablePadding={disablePadding}
                isShowHeader={isShowHeader}
                isBreadcrumbVisible={isBreadcrumbVisible}
                breadCrumbShowBack={breadCrumbShowBack}
                breadCrumbOnBack={breadCrumbOnBack}
                breadCrumbItems={breadCrumbItems}
                isShowRapFireLeaderboardSpotlight={isShowRapFireLeaderboardSpotlight}
                showBlurredBg={showBlurredBg}
                style={backgroundContainorStyle}
            >
                {children}
            </Background>
        </div>
    );
};

export default ParentContainor;
